<template>
  <div
    class="structure-tree-box"
    :class="{ 'is-root': isRoot }"
    :style="boxStyle"
    @mouseover="showActions = true"
    @mouseleave="showActions = false">
    <span>{{ name }}</span>
    <div class="structure-tree-box__actions" v-show="showActions" v-if="group">
      <router-link :to="routeGroup" class="structure-tree-box__actions__item"
        @mouseover.native="showTooltipGroup = true"
        @mouseleave.native="showTooltipGroup = false">
        <ElementTooltip
          :text="'View Group'"
          :active="showTooltipGroup"
        />
        <BaseIcon
          type="zoom"
          :text="'View group'"
        />
      </router-link>
      <router-link :to="routeMembers" class="structure-tree-box__actions__item"
        @mouseover.native="showTooltipUsers = true"
        @mouseleave.native="showTooltipUsers = false">
        <ElementTooltip
          :text="'View members'"
          :active="showTooltipUsers"
        />
        <BaseIcon
          type="user-filter"
          :text="'View members'"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import ElementTooltip from '@elements/ElementTooltip'
import BaseIcon from '@base/BaseIcon'
import { groupMembersRoute } from '@modules/filters'

export default {
  name: 'ParagraphStructureTreeBox',
  props: {
    name: {
      type: String,
      required: true
    },
    group: {
      type: String,
      required: false,
      default: null
    },
    left: {
      type: Number,
      required: true
    },
    top: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    backgroundColor: {
      type: String,
      required: false,
      default: null
    },
    isRoot: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    ElementTooltip,
    BaseIcon
  },
  data () {
    return {
      showActions: false,
      showTooltipGroup: false,
      showTooltipUsers: false
    }
  },
  computed: {
    boxStyle () {
      return {
        left: this.left + 'px',
        top: this.top + 'px',
        width: this.width + 'px',
        height: this.height + 'px',
        backgroundColor: this.backgroundColor || undefined
      }
    },
    routeMembers () {
      return groupMembersRoute(this.group)
    },
    routeGroup () {
      return `/contacts/groups-teams/details/${this.group}`
    }
  }
}
</script>

<style lang="scss">
.structure-tree-box {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: .4rem .8rem;
  font-size: 1.3rem;
  font-weight: font-weights("bold");
  line-height: 1.15;
  color: #1a1a1a;
  border: 2px solid black;
  border-radius: layout(border-radius);
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-break: break-word;

  &.is-root {
    color: black;
    font-size: 1.5rem;
    line-height: 1.2;
  }

  &__actions {
    display: flex;
    position: absolute;
    bottom: -1.9rem;
    right: 0;
    background-color: white;
    border-radius: layout(border-radius);
    box-shadow: 0 0 0 1px tint(black, 90%);
    padding: .3rem .5rem;
    z-index: 10;

    .icon:before {
      color: colors(primary);
      font-size: 1.4rem;
    }

    &__item {
      color: colors(primary);
      position: relative;

      &:not(:last-child) {
        margin-right: .8rem;
      }

      &:hover {
        color: colors(primary);
      }

      .tooltip {
        white-space: nowrap;
      }
    }
  }
}
</style>
